/**
 * Video Category AJAX functions
 */

/**
 * Fetch video categories (initial load or search)
 * @param {string} search - Optional search query
 * @returns {Promise<Object>} Object containing categories and count
 */
export async function fetchVideoCategories(search = '') {
	const formData = new FormData();
	formData.append('action', 'wpcore_search_video_categories');
	// eslint-disable-next-line no-undef
	formData.append('nonce', wpcore.nonce);
	formData.append('search', search);
	// eslint-disable-next-line no-undef
	const stageId = new URLSearchParams(window.location.search).get('stage_id') || (wpcore.pageStageId > 0 ? String(wpcore.pageStageId) : null);
	if (stageId) {
		formData.append('stage_id', stageId);
	}

	try {
		// eslint-disable-next-line no-undef
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData
		});
		const data = await response.json();

		if (data.success) {
			return data.data;
		} else {
			console.error('Error fetching video categories:', data.data?.message);
			return { categories: [], count: 0 };
		}
	} catch (error) {
		console.error('Error fetching video categories:', error);
		return { categories: [], count: 0 };
	}
}
